module.exports = __webpack_public_path__ + "img/text-slash.ef0ff5ec.svg";